<script>
import Layout from '@layouts/login'
import api from '@utils/api'

export default {
  name: 'PasswordReset',
  components: {
    Layout,
  },
  data() {
    return {
      valid: true,
      password: '',
      password_confirm: '',
      passwordChangeLoading: false,
      tryingToChangePassword: false,
      error: null,
    }
  },
  computed: {
    newPasswordRules() {
      return [
        value =>
          (!!value &&
            /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$/.test(
              value
            )) ||
          this.$i18n.t('validation__password_rules'),
      ]
    },
    confirmPasswordRules() {
      return [
        value => {
          if (!value) {
            return this.$i18n.t('validation__password_required')
          }
          if (value !== this.password) {
            return this.$i18n.t('validation__not_same_password')
          }
          return true
        },
      ]
    },
  },
  beforeCreate() {
    api
      .validateToken(this.$route.params.token)
      .then(() => {})
      .catch(error => {
        this.error = error
        this.$router.push('/login')
      })
  },

  methods: {
    tryToChangePassword() {
      if (!this.$refs.passwordForm.validate()) {
        this.valid = false
        this.tryingToChangePassword = false
        return
      }
      this.tryingToChangePassword = true
      return this.resetPassword()
    },
    resetPassword() {
      this.passwordChangeLoading = true
      api
        .resetPassword(this.$route.params.token, this.password)
        .then(response => {
          if (response) {
            this.$store.commit('notifications/ADD', {
              type: 'success',
              message: this.$t(response),
            })
            this.$store.dispatch('auth/logOut').then(() => {
              this.$store.commit('data/SET_DICTIONARY_LOADING_STATUS', false)
              this.$router.push('/login')
            })
          }
        })
        .catch(() => {
          setTimeout(() => this.$router.push({ name: 'forgotPassword' }), 2000)
        })
      this.passwordChangeLoading = false
    },
  },
}
</script>

<template>
  <Layout>
    <v-flex 
      v-if="!error" 
      :class="$style.header">{{ $t('label__set_new_password') }}</v-flex>
    <v-flex v-if="!error">
      <v-form
        ref="passwordForm"
        v-model="valid"
        lazy-validation
      >
        <v-text-field
          v-model="password"
          :rules="newPasswordRules"
          :label="$t('label__new_password')"
          type="password"
          required
        />
        <v-text-field
          v-model="password_confirm"
          :rules="confirmPasswordRules"
          :label="$t('label__confirm_password')"
          type="password"
          required
        />
      </v-form>
      <v-btn
        :loading="passwordChangeLoading"
        :disabled="passwordChangeLoading || !valid"
        color="primary"
        type="submit"
        @click="tryToChangePassword()"
      >
        {{ $t('buttons__update') }}
      </v-btn>
    </v-flex>
  </Layout>
</template>


<style lang="scss" module>
@import '@design';

.header {
  font-size: 18px;
  font-weight: bolder;
}
</style>
